<div class="jumbotron text-center" >
    <h1>400 Invalid URL</h1>
    <p>The link is either expired or invalid or your application has already been submitted for further processing.</p>
    <!-- <p>You will be redirected back, dont refresh or close the page.</p> -->
</div>